var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tooltip',{attrs:{"text":_vm.$t('dial'),"position":"bottom"}},[_c('vs-button',{attrs:{"radius":"","color":"primary","type":"border","icon":"dialpad","size":"small"},on:{"click":function($event){$event.preventDefault();return _vm.call.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }